import { LayoutSetup, StepItemsList } from "@/components/setup/layout-setup";
import { useTranslation } from "@/hooks/useTranslation";
import { SetupResubscriptionBillingIntroductionPage } from "./resubscription-billing/0-introduction";
import { SetupResubscriptionBillingPaymentMethodPage } from "./resubscription-billing/1-payment-method";
import { SetupResubscriptionBillingFinishPage } from "./resubscription-billing/2-finish";

export const SetupResubscriptionBilling = () => {
  const { t } = useTranslation();

  const steps: StepItemsList = [
    {
      id: "introduction",
      label: t("setup.resubscriptionBilling.steps.introduction"),
      element: <SetupResubscriptionBillingIntroductionPage />,
    },
    {
      id: "payment-method",
      label: t("setup.resubscriptionBilling.steps.paymentMethod"),
      element: <SetupResubscriptionBillingPaymentMethodPage />,
    },
    {
      id: "finish",
      label: t("setup.resubscriptionBilling.steps.finish"),
      element: <SetupResubscriptionBillingFinishPage />,
    },
  ];

  return <LayoutSetup steps={steps} />;
};
